// extracted by mini-css-extract-plugin
export default {"wrapper-div":"Search_wrapper-div__GRkH0","form-control":"Search_form-control__202wc","error-wrapper":"Search_error-wrapper__pgAk5"};